import {
  CustomFieldFillable,
  CustomFieldType,
} from '@/common/components/support/support.types';

export default function initCustomFields(): CustomFieldFillable[] {
  return [{
    id: Math.random().toString(36),
    name: '',
    type: CustomFieldType.TEXT,
    options: [],
    inVirtualTerminal: false,
    inHPP: false,
    inInvoice: true,
    required: false,
    value: '',
  }];
}
